import { useCallback } from 'react';

type ToggleCheckboxHook<T> = (
    sectionKey: string,
    value: T | null,
    options: T[]
) => void;

const useToggleCheckbox = <T extends { id: number | string }>(
    setCheckedLists: React.Dispatch<React.SetStateAction<Record<string, T[]>>>
) => {
    const toggleCheckbox: ToggleCheckboxHook<T> = useCallback(
        (sectionKey, value, options) => {
            setCheckedLists((prev) => {
                const currentList = prev[sectionKey] || [];

                // 전체 선택 / 해제
                if (!value) {
                    const isAllSelected = currentList.length === options.length;
                    return {
                        ...prev,
                        [sectionKey]: isAllSelected ? [] : options
                    };
                }

                // 개별 선택 / 해제
                const exists = currentList.some((item) => item.id === value.id);
                const updatedList = exists
                    ? currentList.filter((item) => item.id !== value.id)
                    : [...currentList, value];

                return {
                    ...prev,
                    [sectionKey]: updatedList
                };
            });
        },
        [setCheckedLists]
    );

    return { toggleCheckbox };
};

export default useToggleCheckbox;

// import { Dispatch, SetStateAction, useCallback } from 'react';

// const useToggleCheckbox = (setCheckedList: Dispatch<SetStateAction<any[]>>) => {
//     const toggleCheckbox = useCallback(
//         (value: any, options: any[]) => {
//             console.log(value);
//             // 전체 선택, 전체 해제
//             if (!value) {
//                 return setCheckedList((prev) =>
//                     prev.length === options.length ? [] : options
//                 );
//             }
//             setCheckedList((prev) => {
//                 // 선택 해제, '전체' 해제
//                 if (!!prev.filter((data) => data.id === value.id).length) {
//                     console.log('dd');
//                     return prev.filter((data) => data.id !== value.id);
//                 }
//                 return [...prev, value];
//             });
//         },
//         [setCheckedList]
//     );
//     return { toggleCheckbox };
// };

// export default useToggleCheckbox;
